import { inject } from '@vue/composition-api';

var contextKey = Symbol('tabsContext');
function useTabsContext() {
    return inject(contextKey);
}

export { contextKey, useTabsContext };
